module.exports = __webpack_public_path__ + "img/error.488474ab.svg";